// eslint-disable-next-line no-restricted-imports
import { t as translate } from "i18next";

// eslint-disable-next-line id-length
export function t(
  key: string,
  defaultValue?: string,
  options?: Record<string, string>
) {
  return translate(key, defaultValue, options);
}
